import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import HolidayForm from "./HolidayForm";
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import { 
	getHolidayList, 
	doHolidayDelete,
	doHolidayReset,
} from "../../../../redux/holiday/holidayState";
import { COUNTRY_FLAG_ICONS } from "variables/constants";


const HolidayTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {


  	const columns = [
		{
	        title: `Holiday Name`,
	        dataIndex: 'hol_name',
	        key: 'hol_name',
	        width: '58%',
	        render:(hol_name) => <span>{hol_name}</span> 
	    },
		{
	        title: `Type`,
	        dataIndex: 'hol_type_name',
	        key: 'hol_type_name',
	        width: '15%',
	        render:(hol_type_name) => <span>{hol_type_name}</span> 
	    },
		{
			title: 'Country',
			key: 'country_name',
			width: '15%',
			render: (_, record) => {

				return (
				<div className="flex items-center gap-2">
					{COUNTRY_FLAG_ICONS?.[record?.country?.cou_code] ?? null}
					<span>{record?.country_name || '-'}</span>
				</div>
				);
			}
		},
	    {
	        title: <PopupButton id="add_holiday" title="Add Holiday" label="Add" btnClass="btn-small">
						<HolidayForm recordId="0" mode="edit" />
					</PopupButton>,
	        dataIndex: 'hol_id',
	        key: 'hol_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
									baseRoute="/console/holidays" 
									recordId={record?.hol_id} 
									deleteHandler={doDelete} 
									allowEdit={false}
									viewMode="modal"
									title="Edit Holiday"
									closeHandler={doRecordReset}
									viewHandler={(recordId, doRecordReset ) => (
										<HolidayForm 
											recordId={recordId} 
											mode="edit" 
											onCancel={doRecordReset} 
										/>
									)}
								/>
	    },
    ];
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.hol_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.holiday.holidayList?.items,
	pagination: state.holiday.holidayList?.pagination,
	filters: state.holiday.holidayList?.filters,
	requesting: state.holiday.holidayList?.requesting,
	error: state.holiday.holidayList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getHolidayList(filters)),
	doDelete: (id) => dispatch(doHolidayDelete(id)),
	doRecordReset: () => dispatch(doHolidayReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HolidayTable);
